import { BaseController } from '../../base/controller';

import template from './userImport.html';

class UserImportController extends BaseController {
  constructor(controllerService, userImportService, $document, notificationService ) {
    'ngInject';
    super({controllerService, userImportService, $document, notificationService });
  }

  close() {
    this.userImportService.closeModal();
  }

  uploadFile() {
    let f = this.$document[0].getElementById('fileUpload').files[0];
    
    if(!f) {
      return this.notificationService.error(this.$translate.instant('userImport.modal.upload.error.fileNotFound'));
    }
    this.isLoading = true;
    this.userImportService.uploadTemplate(f).then(result => {
      this.userImportService.closeModal();
    }).finally(() => {
      this.isLoading = false;
    });
  }
}

export default {
  restrict: 'E',
  bindings: {},
  template,
  controllerAs: 'vm',
  controller: UserImportController
};
